import { dataHooks as createDataHooks } from '@wix/data-hooks'

export const dataHooks = createDataHooks<{
  btn: {}
  title: {}
  description: {}
  image: {}
}>('wix-studio-image-buttons')
